import * as React from 'react';
import { observer } from 'mobx-react';

import { UitkEmptyState } from 'uitk-react-empty-state';
import { AnalyticsType, FlightsActionableErrorMessaging } from 'types/shared';
import { isFightsSearch, trackAnalytics } from 'utility';
import { useStores } from 'utility/hooks';

interface FailedRequestMessagingProps {
  flightsActionableErrorMessaging: FlightsActionableErrorMessaging;
}

export const FailedRequestMessaging = observer(({ flightsActionableErrorMessaging }: FailedRequestMessagingProps) => {
  const { icon, title, message, action } = flightsActionableErrorMessaging;
  const { id } = icon;
  const { searchCriteriaStore, routeStore, analytics, context, page } = useStores();
  const { displayAction, accessibilityMessage, relativeURI } = action;
  const analyticsType: AnalyticsType = action && action.analytics;

  const onClickAction = () => {
    if (analytics != null && analyticsType != null) {
      trackAnalytics(analyticsType, analytics);
    }

    if (isFightsSearch(page)) {
      if (searchCriteriaStore == null || routeStore == null) {
        location.reload(true);
      } else {
        searchCriteriaStore.triggerSearch(routeStore, context, true, true);
      }
    } else {
      if (relativeURI) {
        location.href = relativeURI.relativePath;
      } else {
        location.reload(true);
      }
    }
  };

  return (
    <div className="uitk-type-center all-y-padding-twelve all-x-padding-twelve" data-test-id="failed-request-messaging">
      <UitkEmptyState
        icon={id}
        heading={title}
        headingLevel="h2"
        body={message}
        buttonText={displayAction}
        className="all-y-margin-twelve"
        onClick={onClickAction}
      />
      {accessibilityMessage && <span className="is-visually-hidden">{accessibilityMessage}</span>}
    </div>
  );
});
